module.exports = __webpack_public_path__ + "img/fig_5.e3985f58.svg";